import GoogleTagManagerScript from 'app/components/scripts/GoogleTagManagerScript';
import MedalliaScript from 'app/components/scripts/MedalliaScript';

// TODO DEVIN-1702: Add Pendo script w/ 'beforeInteractive' strategy
//  because it is located in the <head> and has an inline script.

// TODO DEVIN-1702: Add Google Tag Manager noscript w/ 'afterInteractive' strategy because it is located in the <body>.

// Convenience component that includes all third-party scripts
export const ThirdPartyScripts = () => {
  return (
    <>
      <GoogleTagManagerScript />
      <MedalliaScript />
    </>
  );
};
